import $ from 'jquery'
window.$ = window.jQuery = $

import './bugsnag'
import './jquery-ui-1.13.2.custom'
import './jquery.form.min'
import './jquery.jscroll'
import './jquery.jscrollpane'
import './jquery.mousewheel'
import './jquery.numberformatter.min'
import './jquery.splitter'
import './modernizr'
import './rails'
import './rangeslider'
